// extracted by mini-css-extract-plugin
module.exports = {"pane":"pane__Y-6Hv","sub-panes":"sub-panes__2Ysgk","sub-pane":"sub-pane__v9eaL"};